import React from 'react';
type ValuePillar = {
  emoji: string;
  title: string;
  description: string;
  titleClassName: string;
};
const valuePillars: ValuePillar[] = [{
  emoji: '💊',
  title: 'Stock Confidence',
  description: 'Community-reported confidence that a pharmacy is likely to have your medication in stock. Based on recent patient visits, not live inventory.',
  titleClassName: 'text-[#1C1C1C]'
}, {
  emoji: '⏱️',
  title: 'Wait Time',
  description: 'Time from arriving to pickup, based on what patients actually experienced on their most recent visit.',
  titleClassName: 'text-[#B46423]'
}, {
  emoji: '🤝',
  title: 'Empathetic Care',
  description: 'How patients rate the respect, dignity, and attention they received at the counter. The part no star rating has ever captured.',
  titleClassName: 'text-[#008F82]'
}];
export function HowItWorksSection() {
  return <section id="how-it-works" className="w-full bg-[#F7F7F7] py-16 sm:py-20" aria-labelledby="how-it-works-title" data-id="element-91" data-mp="1i6ek8joziw3p">
      <div className="mx-auto w-full px-6 md:px-12 lg:px-16" data-id="element-92" data-mp="wcqyw42lmpmc">
        <div className="mx-auto max-w-3xl text-center" data-id="element-93" data-mp="118ek68dymymk">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#777]" data-id="element-94" data-mp="15bko39dlodpv">
            How it works
          </p>
          <h2 id="how-it-works-title" className="mt-3 text-[26px] font-extrabold leading-tight tracking-tight text-[#1C1C1C] sm:text-3xl" data-id="element-95" data-mp="1aanw92ovn022">
            Stock confidence, wait time, empathetic care — explained.
          </h2>
        </div>

        <div className="mt-10 flex w-full flex-col gap-6 md:flex-row" data-id="element-96" data-mp="mktfwb5cmtd2">
          {valuePillars.map(pillar => <article key={pillar.title} className="flex min-h-[244px] flex-1 flex-col border border-gray-100 bg-white px-6 py-8 text-center shadow-sm" data-id="element-97" data-mp="rc37viede8s4">
              <span className="text-4xl leading-none" role="img" aria-label={pillar.title} data-id="element-98" data-mp="3v04updu90yet">
                {pillar.emoji}
              </span>
              <h3 className={`mt-5 text-base font-bold ${pillar.titleClassName}`} data-id="element-99" data-mp="x7l6too0t89i">
                {pillar.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-[#686868]" data-id="element-100" data-mp="1b0axw7iep3dh">
                {pillar.description}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}